var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"formPart"},[_c('formElement',{attrs:{"data":_vm.data,"callback":function(val) { _vm.checkPassword(val) }}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }